import { render, staticRenderFns } from "./WebsiteAbout.vue?vue&type=template&id=f3b14104&scoped=true&"
import script from "./WebsiteAbout.vue?vue&type=script&lang=js&"
export * from "./WebsiteAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b14104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3b14104')) {
      api.createRecord('f3b14104', component.options)
    } else {
      api.reload('f3b14104', component.options)
    }
    module.hot.accept("./WebsiteAbout.vue?vue&type=template&id=f3b14104&scoped=true&", function () {
      api.rerender('f3b14104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/WebsiteAbout.vue"
export default component.exports